import { observer } from 'mobx-react';
import * as React from 'react';
import LearningCollection from '.';
import LearningCollectionsStore from '../Store';
import LearningCollectionStore from './Store';

interface Props {
  store: LearningCollectionsStore;
}

class New extends React.Component<Props, {}> {
  learningCollectionStore: LearningCollectionStore;

  constructor(props: Props) {
    super(props);
    this.learningCollectionStore = new LearningCollectionStore();
  }

  componentDidMount() {
    this.learningCollectionStore.loading();
    this.learningCollectionStore.productLicensesStore.loading();
  }

  render() {
    return <LearningCollection store={this.learningCollectionStore} />;
  }
}

export default observer(New);
